import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ExamSummary, Intake, Patient, ScheduleResponse, PatientScheduledVisits } from '../models';
import { Api, Session } from '../services/index';
import { Observable } from 'rxjs/Observable';


@Component({
  selector: 'app-exam-request',
  templateUrl: './exam-request.html'
})

export class ExamRequestComponent implements OnInit {
  @ViewChild('myModal') _modalMsg: ElementRef;
  @ViewChild('myModalLearnMore') _modalLearnMore: ElementRef;

  activeExam: Intake;
  examHistories: ExamSummary[] = [];
  loading = false;
  policyType: number = 1;
  scheduleResponse: PatientScheduledVisits[] = [];
  public isRequesting: boolean;
  constructor(private api: Api,
    private route: ActivatedRoute,
    private router: Router,
    private session: Session) {
    this.loading = true;
    this.isRequesting = true;

    let _getPatientPolicyType = this.api.getPatientPolicyType(this.session.patientId).map(patientPolicyResult => {
      this.policyType = patientPolicyResult;
    }, ex => {
    });

    let _getPatientScheduledIntakes = this.api.getPatientScheduledIntakes(this.session.patientId).map(scheduledIntakeResult => {
      this.scheduleResponse = scheduledIntakeResult;
    }, ex => {
    });

    let _getExamSummary = this.api.getExamSummary(this.session.patientId).map(examSummaryResult => {
      this.examHistories = examSummaryResult;
    }, ex => {
    });

    let _getActiveIntake = this.api.getActiveIntake(this.session.patientId).map(activIntakeResult => {
      this.activeExam = activIntakeResult;
    }, ex => {
    });


    Observable.forkJoin([_getPatientPolicyType,
      _getPatientScheduledIntakes,
      _getExamSummary,
      _getActiveIntake
    ]).subscribe(results => {
      this.loading = false;
      this.isRequesting = false;
    }, err => {
      this.loading = false;
      this.isRequesting = false;
    });

  }

  ngOnInit() {
    this.session.patient = new Patient;
  }

  loadPastExamDetail(intakeId) {
    this.router.navigate(['/exam-history-patient/' + intakeId]);
  }

  gotoDashboard() {
    this.router.navigate(['/dashboard']);
  }
  gotoExam(intakeId){
    this.router.navigate(['/thankyou/' + intakeId]);
  }
}
